// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__huNeT","modalFooterButton":"ModalNotes_modalFooterButton__1OVEY"};